import React, { useState } from "react";

import EventItem from "./EventItem";

import { SonicEventData } from "../../common/classes/SonicEvent";

import { getLargestImage, getDefaultImage } from "../../utils/GeneralUtils";

import ArchiveWrapper from "../../common/archive/ArchiveWrapper";
import AdvancedSearchEvent from "./AdvancedSearchEvent";
import { PageTypes } from "../../utils/PageTypes";
import FinishedEventItem from "./FinishedEventItem";
import SwitchListButton from "./SwitchListButton";
import { SearchParam } from "../../common/archive/ListSearchFunc";
import PageTitle from "../../common/PageTitle";
import PageHelperModal from "../../common/page-help/PageHelperModal";
import { SonicTermData } from "../../common/classes/SonicTerm";

type Props = {
  isLoading: boolean;
  sorted_events: SonicEventData[];
  totalEntries: number;
  totalPages: number;
  currentPage: number;
  perView: number;
  keywordParam: string;
  isNormalArchive: boolean;
  handlePerView: (value: number) => void;
  handleArchiveType: (isNormalArchive: boolean) => void;
  searchHandler: (params: Array<SearchParam>) => void;
  clearSearch: () => void;
  typeParams: Array<string>;
  gameParams: Array<string>;
  startTimeParam: string;
  eventTypeOptions: Array<SonicTermData>;
  gameOptions: Array<SonicTermData>;
  startTimesOptions: Array<[string, string]>;
};

const EventPage: React.FC<Props> = ({
  isLoading,
  sorted_events,
  totalEntries,
  totalPages,
  currentPage,
  perView,
  keywordParam,
  isNormalArchive,
  handlePerView,
  handleArchiveType,
  searchHandler,
  clearSearch,
  typeParams,
  gameParams,
  startTimeParam,
  eventTypeOptions,
  gameOptions,
  startTimesOptions,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const handleHelpModal = () => {
    setShowModal(!showModal);
  };

  return (
    <main>
      <PageTitle
        title="EVENT"
        subtext="イベント"
        handleHelpModal={handleHelpModal}
      />
      <ArchiveWrapper
        title={isNormalArchive ? "イベント一覧" : "終了したイベント一覧"}
        hasResults={sorted_events.length == 0 ? false : true}
        isLoading={isLoading}
        currentPage={currentPage}
        perView={perView}
        totalEntries={totalEntries}
        totalPages={totalPages}
        handlePerView={handlePerView}
        searchComponent={
          <>
            <SwitchListButton
              titles={["イベント一覧", "終了したイベント一覧"]}
              isNormalArchive={isNormalArchive}
              handleArchiveType={handleArchiveType}
            />
            <AdvancedSearchEvent
              keywordParam={keywordParam}
              typeParams={typeParams}
              gameParams={gameParams}
              startTimeParam={startTimeParam}
              eventTypeOptions={eventTypeOptions}
              gameOptions={gameOptions}
              startTimesOptions={startTimesOptions}
              clearSearch={clearSearch}
              searchHandler={searchHandler}
            />
          </>
        }
        type={isNormalArchive ? PageTypes.Event : PageTypes.FinishedEvent}
      >
        {sorted_events?.map((event, i) => {
          if (isNormalArchive) {
            return (
              <EventItem
                key={i}
                id={event.id}
                name={event.name}
                type={event.event_type}
                img={
                  event.imgs?.length > 0
                    ? getLargestImage(event.imgs[0])
                    : getDefaultImage()
                }
                start_date={new Date(event.start_date * 1000)}
                end_date={new Date(event.end_date * 1000)}
                tags={event.tags}
                isJikei={
                  event.role_restriction.includes("jikei_student")
                    ? true
                    : false
                }
              />
            );
          } else {
            return (
              <FinishedEventItem
                key={i}
                id={event.id}
                name={event.name}
                type={event.event_type}
                img={
                  event.imgs?.length > 0
                    ? getLargestImage(event.imgs[0])
                    : getDefaultImage()
                }
                start_date={event.start_date}
                end_date={event.end_date}
                isJikei={
                  event.role_restriction.includes("jikei_student")
                    ? true
                    : false
                }
              />
            );
          }
        })}
      </ArchiveWrapper>

      {showModal === true ? (
        <PageHelperModal
          handleHelpModal={handleHelpModal}
          helpTitle="イベントとは？"
          helpText={
            "eスポーツ関連イベントが掲載されています。SELeCT会員はイベントの登録ができます。"
          }
        />
      ) : null}
    </main>
  );
};

export default EventPage;
